module.exports = __webpack_public_path__ + "static/media/hsu_hung_ke.591717d9.jpg";